<!-- Button -->
<button mat-button [matMenuTriggerFor]="userActions">
    <div class="flex items-center">
        <span class="text-pantoneWhite000">
            @if(isAuthenticated){
            {{user?.name}}
            {{user?.family_name}}
            {{user?.middle_name}}
            &nbsp;
            } @if(!isAuthenticated){
            Iniciar sesión
            }
        </span>
        &nbsp;
        <span class="relative">
            @if (showAvatar && user?.picture) {
            <img class="h-7 w-7 rounded-full" [src]="user?.picture" />
            }
            @if (!showAvatar || !user?.picture) {
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
            }
            <span class="absolute bottom-0 right-0 h-2 w-2 rounded-full" [ngClass]="{
                'mb-px mr-px': !showAvatar || !user?.picture,
                'bg-green-500': user?.status === 'online',
                'bg-amber-500': user?.status === 'away',
                'bg-red-500': user?.status === 'busy',
                'bg-gray-400': user?.status === 'not-visible',
            }"></span>
        </span>
    </div>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    @if(isAuthenticated){
    <!-- User Info Section -->
    <div class="px-4 py-3 border-b">
        <div class="flex flex-col space-y-3">
            <!-- Email -->
            <div class="flex flex-col space-y-1">
                <span class="text-xs font-medium text-secondary uppercase tracking-wider">
                    Conectado como
                </span>
                <div class="flex items-center justify-between gap-3 group">
                    <span class="text-sm font-medium text-default truncate max-w-[200px]">
                        {{ user?.email }}
                    </span>
                    <button 
                        mat-icon-button 
                        class="!h-8 !w-8 opacity-0 group-hover:opacity-100 transition-opacity" 
                        (click)="copyToClipboard(user?.email, 'Email'); $event.stopPropagation()"
                        [matTooltip]="'Copiar email'">
                        <mat-icon 
                            class="icon-size-5 text-hint" 
                            [svgIcon]="'heroicons_outline:clipboard-document'">
                        </mat-icon>
                    </button>
                </div>
            </div>
            
            <!-- User ID -->
            <div class="flex flex-col space-y-1">
                <span class="text-xs font-medium text-secondary uppercase tracking-wider">
                    ID de usuario
                </span>
                <div class="flex items-center justify-between gap-3 group">
                    <span class="text-xs font-mono text-hint truncate max-w-[200px]">
                        {{ user?.sub }}
                    </span>
                    <button 
                        mat-icon-button 
                        class="!h-8 !w-8 opacity-0 group-hover:opacity-100 transition-opacity" 
                        (click)="copyToClipboard(user?.sub, 'ID de usuario'); $event.stopPropagation()"
                        [matTooltip]="'Copiar ID'">
                        <mat-icon 
                            class="icon-size-5 text-hint" 
                            [svgIcon]="'heroicons_outline:clipboard-document'">
                        </mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
    } @if(!isAuthenticated){
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>
                No has iniciado sesión
            </span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    }
    @if(isAuthenticated){
    <!-- <button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Perfil</span>
    </button> -->
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>
            Cerrar sesión
        </span>
    </button>
    } @if(!isAuthenticated){
    <button mat-menu-item (click)="signIn()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-left-on-rectangle'"></mat-icon>
        <span>Iniciar sesión</span>
    </button>
    <button mat-menu-item (click)="forgotPassword()">
        <mat-icon [svgIcon]="'heroicons_outline:key'"></mat-icon>
        <span>Recuperar contraseña</span>
    </button>
    }
    <!-- <button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
        <span>Settings</span>
    </button> -->
    <!-- <button mat-menu-item [matMenuTriggerFor]="userStatus">
        <mat-icon [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"></mat-icon>
        <span>Status</span>
    </button> -->

</mat-menu>

<mat-menu class="user-status-menu" #userStatus="matMenu">
    <button mat-menu-item (click)="updateUserStatus('online')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('away')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('busy')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('not-visible')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu>